import { createRouter } from "@tanstack/react-router"

import { PageNotFound } from "@/components/feedback/page-not-found"
import { PagePending } from "@/components/feedback/page-pending"
import { SiteError } from "@/components/feedback/site-error"

import { routeTree } from "./routeTree.gen"

/**
 * Search params as plain `?a=b` (what the Next site's links and forms
 * produced, `/help?q=…`), not the router's default JSON encoding: every
 * value here is a string.
 */
function parseSearch(searchStr: string) {
  return Object.fromEntries(new URLSearchParams(searchStr))
}
function stringifySearch(search: Record<string, unknown>) {
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(search)) {
    if (value !== undefined && value !== null) params.set(key, String(value))
  }
  const out = params.toString()
  return out ? `?${out}` : ""
}

export function getRouter() {
  return createRouter({
    routeTree,
    scrollRestoration: true,
    defaultPreload: "intent",
    // A loading view as soon as a page takes a moment (TanStack waits 1 s,
    // showing the previous page under the new address), kept long enough
    // not to flash.
    defaultPendingMs: 150,
    defaultPendingMinMs: 300,
    defaultPendingComponent: PagePending,
    parseSearch,
    stringifySearch,
    // `app/(site)/error.tsx` and `not-found.tsx` for every page without its own.
    defaultErrorComponent: SiteError,
    defaultNotFoundComponent: PageNotFound,
  })
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
